import {uniq, sortBy, flow, map, filter} from 'lodash/fp';

import {School} from '../../../api/types/__generated__/data-contracts';

type FilterItem = {
    labelText: string
    value: string
}

export const transformRegionFilterFromSchools = (data: School[]): Array<FilterItem> => {
    const uniqueRegions = flow([
        map((item: School) => item?.region?.name),
        uniq,
        filter(Boolean),
        map(region => ({
            labelText: region,
            value: region
        })),
        sortBy(['labelText'])
    ])(data);

    return uniqueRegions;
};
